import { useSearchParams } from 'react-router-dom';

import { Card } from '@mantine/core';

import { UnifiedLoginForm } from '@gtintel/signin/components/auth/UnifiedLoginForm';
import { AuthLayout } from '@gtintel/signin/components/layout/AuthLayout';

export const Login: React.FC = () => {
  const [searchParams] = useSearchParams();

  // Check multiple possible redirect URL parameters in priority order
  const sourceUrl =
    searchParams.get('referer') ||
    searchParams.get('redirect') ||
    searchParams.get('redirect_url') ||
    searchParams.get('return_url') ||
    searchParams.get('next') ||
    undefined;

  return (
    <AuthLayout title="Sign in" subtitle="Enter your email to continue">
      <Card withBorder shadow="lg" radius="md" p="lg" bd="2px solid var(--mantine-color-navy-9)">
        <UnifiedLoginForm sourceUrl={sourceUrl} />
      </Card>
    </AuthLayout>
  );
};
